import { render, staticRenderFns } from "./TestBuyerHomePage.vue?vue&type=template&id=8a89f8a2"
import script from "./TestBuyerHomePage.vue?vue&type=script&lang=js"
export * from "./TestBuyerHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports